import { TypeBody1, TypeH2 } from "../../atoms/fonts/Types";
import { IconClock, IconGlobe, IconStar, IconTarget } from "../../atoms/icons/Icons";
import { CountUp } from "../../atoms/util/reveal/CountUp";
import { useT } from "../../../i18n/LanguageContext";
import "./SectionOneContent.css";

const POINT_ICONS = [IconStar, IconClock, IconGlobe, IconTarget];

export function SectionOneContent() {
	const { t } = useT();
	const stats = t("about.stats");
	const points = t("about.points");

	return (
		<div className="aboutContent">
			<div className="aboutContent_intro">
				<span className="-eyebrow" data-reveal="rise">
					{t("about.eyebrow")}
				</span>
				<TypeH2 className="aboutContent_title">
					<span data-reveal="tide" style={{ "--d": 1 }}>
						{t("about.title")}
					</span>
				</TypeH2>
				<div className="aboutContent_body" data-reveal="rise" style={{ "--d": 3 }}>
					<TypeBody1>{t("about.body")}</TypeBody1>
				</div>
			</div>

			<dl className="aboutContent_stats">
				{Array.isArray(stats) &&
					stats.map((s, i) => (
						<div key={i} className="aboutContent_stat" data-reveal="chart" style={{ "--d": i * 2 }}>
							<dt className="aboutContent_statLabel">{s.label}</dt>
							<dd className="aboutContent_statValue">
								<CountUp value={s.value} />
							</dd>
						</div>
					))}
			</dl>

			<ul className="aboutContent_points">
				{Array.isArray(points) &&
					points.map((p, i) => {
						const Icon = POINT_ICONS[i] || IconStar;
						return (
							<li key={i} className="aboutPoint" data-reveal="rise" style={{ "--d": i }}>
								<span className="aboutPoint_icon" aria-hidden="true">
									<Icon />
								</span>
								<span className="aboutPoint_title">{p.title}</span>
								<span className="aboutPoint_body">{p.body}</span>
							</li>
						);
					})}
			</ul>
		</div>
	);
}
